export default "__VITE_ASSET__B44TRQTM__"